import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core'
import { MatTabChangeEvent } from '@angular/material'
// tslint:disable-next-line:max-line-length
import { MarketLevelGlobalIndexMemberComponent } from 'app/market-level/market-level-global-index-member/market-level-global-index-member.component'
import { MarketLevelHistoricalDataComponent } from 'app/market-level/market-level-historical-data/market-level-historical-data.component'
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-market-level',
  templateUrl: './market-level.component.html',
  styleUrls: ['./market-level.component.scss']
})
export class MarketLevelComponent implements OnInit {
  @ViewChild(MarketLevelGlobalIndexMemberComponent)
  marketLevelGlobalIndexMemberComponent: MarketLevelGlobalIndexMemberComponent

  @ViewChild(MarketLevelHistoricalDataComponent)
  marketLevelHistoricalDataComponent: MarketLevelHistoricalDataComponent

  constructor() {}

  ngOnInit() {}

  onTabClick(event: MatTabChangeEvent) {
    switch (event.index) {
      case 1:
        this.marketLevelHistoricalDataComponent.initialChart()
        break
      case 2:
        this.marketLevelGlobalIndexMemberComponent.initialChart()
        break
      default:
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-level/market-level.component.ts